/*
 *
 * Dashboard actions
 *
 */

import { createAction } from '@reduxjs/toolkit';
import dashboardConstants from './constants';
import { InformationData } from '../../models/Information';
import { WalletSummaryResponse } from '../../apischema/savingwallet';

export const defaultAction = createAction(
  dashboardConstants.DEFAULT_ACTION,
  function prepare() {
    return { payload: {} };
  },
);

export const defaultActionSuccess = createAction(
  dashboardConstants.DEFAULT_ACTION_SUCCESS,
  function prepare(data: any) {
    return { payload: { data } };
  },
);

export const defaultActionError = createAction(
  dashboardConstants.DEFAULT_ACTION_ERROR,
  function prepare(error: any) {
    return { payload: { error } };
  },
);

// Information Actions
export const fetchInformation = createAction(
  dashboardConstants.FETCH_INFORMATION,
  function prepare(params?: { page?: number; pageSize?: number }) {
    return { payload: { params: params || { page: 1, pageSize: 5 } } };
  },
);

export const fetchInformationSuccess = createAction(
  dashboardConstants.FETCH_INFORMATION_SUCCESS,
  function prepare(data: InformationData) {
    return { payload: { data } };
  },
);

export const fetchInformationError = createAction(
  dashboardConstants.FETCH_INFORMATION_ERROR,
  function prepare(error: any) {
    return { payload: { error } };
  },
);

export const getTreeToken = createAction(
  dashboardConstants.GET_TREE_TOKEN,
  function prepare() {
    
    return { payload: {} };
  },
);

export const getTreeTokenSuccess = createAction(
  dashboardConstants.GET_TREE_TOKEN_SUCCESS,
  function prepare(token: string) {
    
    return { payload: { token } };
  },
);

export const getTreeTokenError = createAction(
  dashboardConstants.GET_TREE_TOKEN_ERROR,
  function prepare(error: any) {
    
    return { payload: { error } };
  }
);

// Wallet Summary Actions
export const getWalletSummary = createAction(
  dashboardConstants.GET_WALLET_SUMMARY,
);

export const getWalletSummarySuccess = createAction(
  dashboardConstants.GET_WALLET_SUMMARY_SUCCESS,
  function prepare(data: WalletSummaryResponse) {
    return { payload: { data } };
  },
);

export const getWalletSummaryError = createAction(
  dashboardConstants.GET_WALLET_SUMMARY_ERROR,
  function prepare(error: string) {
    return { payload: { error } };
  },
);
